import React from 'react';
import Modal from './ui/Modal';
import Button from './ui/Button';

const PrivacyModal = ({ isOpen, onClose, onAccept, readOnly = false }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Política de Privacidade e Proteção de Dados">
      <div className="space-y-4 max-h-96 overflow-y-auto pr-2">
        <div>
          <h3 className="font-semibold text-gray-900 mb-2">1. Coleta de Dados</h3>
          <p className="text-sm text-gray-600">
            Coletamos apenas os dados necessários para o funcionamento do serviço, incluindo nome, 
            email, telefone e informações de agendamentos.
          </p>
        </div>

        <div>
          <h3 className="font-semibold text-gray-900 mb-2">2. Uso dos Dados</h3>
          <p className="text-sm text-gray-600">
            Seus dados são utilizados exclusivamente para:
          </p>
          <ul className="list-disc list-inside text-sm text-gray-600 mt-2 space-y-1">
            <li>Gerenciar seus agendamentos</li>
            <li>Enviar notificações e confirmações</li>
            <li>Melhorar nossos serviços</li>
            <li>Comunicação relacionada à plataforma</li>
          </ul>
        </div>

        <div>
          <h3 className="font-semibold text-gray-900 mb-2">3. Compartilhamento de Dados</h3>
          <p className="text-sm text-gray-600">
            Não vendemos, alugamos ou compartilhamos seus dados pessoais com terceiros, exceto:
          </p>
          <ul className="list-disc list-inside text-sm text-gray-600 mt-2 space-y-1">
            <li>Com a barbearia onde você agendou (nome, horário, serviço)</li>
            <li>Quando exigido por lei</li>
            <li>Para proteção de direitos legais</li>
          </ul>
        </div>

        <div>
          <h3 className="font-semibold text-gray-900 mb-2">4. Segurança</h3>
          <p className="text-sm text-gray-600">
            Utilizamos medidas de segurança técnicas e organizacionais para proteger seus dados 
            contra acesso não autorizado, perda ou alteração.
          </p>
        </div>

        <div>
          <h3 className="font-semibold text-gray-900 mb-2">5. Seus Direitos (LGPD)</h3>
          <p className="text-sm text-gray-600">
            De acordo com a Lei Geral de Proteção de Dados (LGPD), você tem direito a:
          </p>
          <ul className="list-disc list-inside text-sm text-gray-600 mt-2 space-y-1">
            <li>Acessar seus dados pessoais</li>
            <li>Corrigir dados incompletos ou desatualizados</li>
            <li>Solicitar a exclusão de seus dados</li>
            <li>Revogar seu consentimento</li>
            <li>Solicitar a portabilidade dos dados</li>
          </ul>
        </div>

        <div>
          <h3 className="font-semibold text-gray-900 mb-2">6. Cookies</h3>
          <p className="text-sm text-gray-600">
            Utilizamos cookies essenciais para o funcionamento da plataforma e para manter 
            sua sessão ativa.
          </p>
        </div>

        <div>
          <h3 className="font-semibold text-gray-900 mb-2">7. Contato</h3>
          <p className="text-sm text-gray-600">
            Para exercer seus direitos ou esclarecer dúvidas sobre privacidade, entre em contato 
            através do email: <strong>barberizeapp01@gmail.com</strong>
          </p>
        </div>

        <div className="bg-indigo-50 p-4 rounded-lg mt-4">
          <p className="text-sm text-indigo-900 font-medium">
            Ao aceitar, você concorda com nossa política de privacidade e confirma que leu e 
            compreendeu como seus dados serão tratados.
          </p>
        </div>
      </div>

      {readOnly ? (
        <div className="mt-6">
          <Button
            variant="primary"
            onClick={onClose}
            className="w-full"
          >
            Fechar
          </Button>
        </div>
      ) : (
        <div className="flex flex-col-reverse sm:flex-row gap-3 mt-6">
          <Button
            variant="secondary"
            onClick={onClose}
            className="w-full sm:w-auto"
          >
            Recusar
          </Button>
          <Button
            variant="primary"
            onClick={onAccept}
            className="w-full sm:w-auto"
          >
            Aceitar e Continuar
          </Button>
        </div>
      )}
    </Modal>
  );
};

export default PrivacyModal;
